import React, { createContext, useContext, useMemo, useState } from 'react';
import { formatCurrency } from '../utils/currency';

const CurrencyContext = createContext();

export const SUPPORTED_CURRENCIES = ['UGX', 'USD', 'EUR', 'GBP'];

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('UGX');

  const value = useMemo(
    () => ({
      currency,
      setCurrency,
      formatPrice: (amount) => formatCurrency(amount, currency),
    }),
    [currency]
  );

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};
